import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';

export interface MenuItems {
  icon: string,
  text: string,
  action: string,
  payload: any
}
@Component({
  selector: 'menu-component',
  templateUrl: 'menu.html'
})
export class MenuComponent {

  items: Array<MenuItems>;

  constructor(private viewCtrl: ViewController, private navParams: NavParams) {
    this.items = this.navParams.get('items');
  }

  open(item) {
    this.viewCtrl.dismiss(item);
  }

}



// WEBPACK FOOTER //
// ./src/components/menu/menu.ts